export default {
  Bunn: {
    type: 'BUNN',
    scanCode: 'BUNN*_tchls_coffee_*',
    name: 'Touchless Coffee Item',
  },
};
